import React from 'react';

interface ILoadingButtonProps {
    label: string;
    disabled?: boolean;
    onClick: () => void;
}

const loadingButton = ({ label, disabled, onClick }: ILoadingButtonProps) => {
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    return (
        <button
            className='msc-loading-btn msc-cta__primary'
            onClick={() => {
                setIsLoading(true);
                onClick();
            }}
            disabled={disabled || isLoading}
        >
            {isLoading && <span className='msc-loading-btn__spinner mr-2'></span>}
            <span>{label}</span>
        </button>
    );
};

export default loadingButton;
